import Vue from 'vue';

export const start = (time) => {
  new Vue().$Progress.start(time);
};

export const finish = () => {
  new Vue().$Progress.finish();
};

export const fail = () => {
  new Vue().$Progress.fail();
};

export const setColor = (color) => {
  new Vue().$Progress.setColor(color);
};
